import { Badge } from 'src/components/atoms';
import styled, { css } from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const UserInformationRowStyled = styled.tr<{ isRowEnabled?: boolean }>`
  width: 100%;
  ${(props) =>
    props.isRowEnabled &&
    css`
      @media (hover: hover) {
        &:hover {
          background-color: ${(props) =>
            props.theme.atlas.semantic.color.surface.variant};
          cursor: pointer;
        }
      }
    `}
`;

export const StyledTd = styled.td<{ width?: string }>`
  padding: 5px;
  width: ${(props) => props.width || 'auto'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:first-child {
    padding-left: 20px;
  }
  &:last-child {
    padding-right: 20px;
  }
`;

export const UserName = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

export const UserDescription = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
  margin: 0;
`;

export const StyledBadge = styled(Badge)`
  width: 100%;
  justify-content: center;
`;
